import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FreightService } from './freight.service';

@Component({
  selector: 'app-product-lookup-dialog',
  templateUrl: './product-lookup-dialog.html',
  styles: [`
    .lookup-content { width: 380px; }
    .full { width: 100%; }
    .mt16 { margin-top: 16px; }
    .muted { color: #777; margin-top: 12px; }
  `]
})
export class ProductLookupDialog {

  searchTerm = '';
  results: any[] = [];
  loading = false;
  searched = false;

  constructor(
    private dialogRef: MatDialogRef<ProductLookupDialog>,
    private freightSvc: FreightService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  search(): void {
    if (!this.searchTerm) { return; }
    this.loading = true; this.searched = true;
    // Heuristic: assume alphanum mix = serial, else code
    const looksLikeSerial = /[a-z]/i.test(this.searchTerm) && /\d/.test(this.searchTerm);
    const obs = looksLikeSerial
      ? this.freightSvc.search(undefined, this.searchTerm)
      : this.freightSvc.search(this.searchTerm);
    obs.subscribe({
      next: res => {
        this.results = res.matches;
        this.loading = false;
        if (!res.serialized && this.results.length) this.select(this.results[0]);
      },
      error: _ => this.loading = false
    });
  }

  select(row: any): void {
    this.dialogRef.close(row); // return chosen match
  }
}
